import { Component, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { AuthStatusService } from './core/auth/auth-status.service';
import { RightsService } from './core/auth/rights.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  private readonly oidcSecurityService = inject(OidcSecurityService);
  private readonly authStatus = inject(AuthStatusService);
  private readonly rightsService = inject(RightsService);
  protected readonly title = signal('IDR Portal');

  constructor() {
    // Single checkAuth() call for the whole app. It processes the /auth-callback
    // authorization code when present, or validates any existing session.
    this.oidcSecurityService.checkAuth().subscribe((loginResponse) => {
      if (loginResponse.isAuthenticated) {
        // Authorization (what can this user do in IDR?) loaded right after authentication
        // succeeds — deliberately separate concerns, per RightsController's own design.
        this.rightsService.load();
      } else if (loginResponse.errorMessage) {
        this.authStatus.checkAuthError.set(loginResponse.errorMessage);
      }
    });
  }
}
